import { atomWithStorage } from "jotai/utils";

export interface Badge {
  type?: string;
}

export const badgesAtom = atomWithStorage<Badge[]>("badge", [], undefined, {
  getOnInit: true
});
